module.exports = __webpack_public_path__ + "img/itx-text-h1.152badf2.svg";